/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import store from "./store";

const manifest: ModuleManifest = {
  storeModules: {
    c3x: store
  }
};

export default manifest;
